/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetDocumentSummaryRequest = {
  /**
   * The id of the document.
   */
  documentId: string;
  /**
   * An optional partition to scope the request to. If omitted, accounts created after 1/9/2025 will have the request scoped to the default partition, while older accounts will have the request scoped to all partitions. Older accounts may opt in to strict partition scoping by contacting support@ragie.ai. Older accounts using the partitions feature are strongly recommended to scope the request to a partition.
   */
  partition?: string | null | undefined;
};

/** @internal */
export const GetDocumentSummaryRequest$inboundSchema: z.ZodType<
  GetDocumentSummaryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
  });
});
/** @internal */
export type GetDocumentSummaryRequest$Outbound = {
  document_id: string;
  partition?: string | null | undefined;
};

/** @internal */
export const GetDocumentSummaryRequest$outboundSchema: z.ZodType<
  GetDocumentSummaryRequest$Outbound,
  z.ZodTypeDef,
  GetDocumentSummaryRequest
> = z.object({
  documentId: z.string(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
  });
});

export function getDocumentSummaryRequestToJSON(
  getDocumentSummaryRequest: GetDocumentSummaryRequest,
): string {
  return JSON.stringify(
    GetDocumentSummaryRequest$outboundSchema.parse(getDocumentSummaryRequest),
  );
}
export function getDocumentSummaryRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetDocumentSummaryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDocumentSummaryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDocumentSummaryRequest' from JSON`,
  );
}
